import { ExamCenterProctorType } from '@exam-center/graphql';
import { useMemo } from 'react';

import { ExamEventProctorDataGrid } from '../../components';
import { proctorTypeLabelMap } from '../../constants';
import { useExamEventDetails } from '../../providers';

export default function ExamEventProctorList() {
  const {
    examEvent: { proctors },
  } = useExamEventDetails();

  const proctorOrder = useMemo(() => Object.values(ExamCenterProctorType), []);

  const rows = useMemo(() => {
    if (!proctors?.length) return [];

    return [...proctors]
      .sort((a, b) => proctorOrder.indexOf(a.type) - proctorOrder.indexOf(b.type))
      .map((proctor) => ({
        id: proctor.id,
        name: [proctor.titleTh, proctor.firstNameTh, proctor.middleNameTh, proctor.lastNameTh]
          .filter(Boolean)
          .join(' '),
        type: proctorTypeLabelMap[proctor.type],
      }));
  }, [proctors, proctorOrder]);

  return <ExamEventProctorDataGrid rows={rows} />;
}
